import { lazy, ComponentType } from "react";

/**
 * Wraps React.lazy so that a failed dynamic import (typically caused by a
 * stale chunk hash after a new deploy) is retried once, and if it still
 * fails, the page is hard-reloaded so the browser fetches the new index.html
 * with the current chunk hashes.
 */
export function lazyWithRetry<T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>,
) {
  return lazy(async () => {
    const reloadedKey = `lazy-retry:${factory.toString()}`;
    try {
      return await factory();
    } catch (err) {
      if (!sessionStorage.getItem(reloadedKey)) {
        sessionStorage.setItem(reloadedKey, "1");
        window.location.reload();
        // Return a never-resolving promise while reload happens
        return new Promise(() => {}) as never;
      }
      throw err;
    }
  });
}
